// @flow
import BaseExtension from './base';

import BaseController from '../players/base';
import StateEntity from '../state';

import { createElement, toggleClass } from '../utils';

import popover from './helpers/popover';
import createSvg, { FULLSCREEN, EXIT_FULLSCREEN } from '../svgs';

import type { Player$ExtensionOptions } from '../types/Options';
import type { Player$State } from '../types/State';

const CN = 'rmp-ext-fullscreen';
const EXIT_CN = `${CN}--exit`;

const ESC_CODE = 27;

export default class FullScreenExtension extends BaseExtension {
   $el: HTMLElement

   constructor(player: BaseController, state: StateEntity, options: Player$ExtensionOptions) {
      super(player, state, options, ['statechanged']);
      this.logger.debug('fullscreen:extension:creating');

      this.render();

      this.addEvent(this.$el, 'click', this.toggle.bind(this));
      this.addEvent(document, 'keyup', this.onKeyup.bind(this));

      if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
         this.addEvent(window, 'resize', this.onResize.bind(this));
      }

      toggleClass(this.$el, EXIT_CN, this.state.isFullScreen());

      this.logger.debug('fullscreen:extension:created');
   }

   render() {
      /** @type {HTMLMediaElement} */
      this.$el = createElement('button', { type: 'button', class: CN, 'data-testid': 'fullscreen' });

      createSvg(this.$el, FULLSCREEN, { class: 'fullscreen-icon'});
      createSvg(this.$el, EXIT_FULLSCREEN, { class: 'exit-fullscreen-icon'});

      const text = () => this.$t(this.state.isFullScreen() ? 'exit-fullscreen' : 'fullscreen');
      setTimeout(() => popover(this, { $button: this.$el, text }) );
   }

   onResize() {
      if (this.state.isFullScreen()) {
         this.bus.emit('fullscreenchanging', true);
      }
   }

   onKeyup(e: KeyboardEvent) {
      if (e.keyCode === ESC_CODE) {
         this.bus.emit('fullscreenchanging', false);
      }
   }

   onStatechanged(state: Player$State) {
      toggleClass(this.$el, EXIT_CN, state.isFullScreen);
   }

   toggle() {
      this.bus.emit('fullscreenchanging');
   }

   getElement() {
      return this.$el;
   }

   destroy() {
      super.destroy();
      const parent = this.$el.parentNode;
      if (parent instanceof HTMLElement) {
         parent.removeChild(this.$el);
      }
      // this.$el = null;
   }
}
